import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user === null) return <div className="min-h-screen flex items-center justify-center text-slate-500">Caricamento...</div>;
  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Accesso effettuato");
      nav("/admin");
    } catch (err) {
      toast.error("Errore accesso", { description: formatError(err.response?.data?.detail) || err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-blue to-blue-900 flex items-center justify-center p-6">
      <div className="w-full max-w-sm bg-white rounded-3xl shadow-xl p-6">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-10 h-10 rounded-xl bg-brand-blue flex items-center justify-center">
            <span className="text-brand-yellow font-heading font-black text-xl">S</span>
          </div>
          <div>
            <div className="font-heading font-black text-brand-blue">Spaccatempo</div>
            <div className="text-[10px] uppercase tracking-widest text-slate-500">Area Admin</div>
          </div>
        </div>
        <h1 className="font-heading font-black text-2xl text-brand-blue mb-4">Accedi</h1>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="h-11 rounded-xl mt-1"
            />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="h-11 rounded-xl mt-1"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full h-12 rounded-full bg-brand-yellow hover:bg-brand-yellow-dark text-brand-blue font-heading font-bold"
          >
            {loading ? "Accesso..." : "Accedi"}
          </Button>
        </form>
      </div>
    </div>
  );
}
